
import { HeroSection } from "@/components/HeroSection";
import { SampleVideo } from "@/components/SampleVideo";
import { PricingSection } from "@/components/PricingSection";
import { ContactSection } from "@/components/ContactSection";
import { OrderForm } from "@/components/OrderForm";
import { FAQSection } from "@/components/FAQSection";
import { motion } from "framer-motion";

const Features = () => {
  return (
    <section id="features" className="py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl font-bold text-navy-800 mb-4">Why Choose Us?</h2>
          <p className="text-xl text-gray-600">Experience the difference with our professional service</p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="bg-white p-6 rounded-lg shadow-lg"
          >
            <h3 className="text-xl font-semibold text-navy-800 mb-4">Professional Editing</h3>
            <p className="text-gray-600">Our team of experienced editors ensures your montage tells a compelling story</p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="bg-white p-6 rounded-lg shadow-lg"
          >
            <h3 className="text-xl font-semibold text-navy-800 mb-4">Custom Music</h3>
            <p className="text-gray-600">Choose from our extensive library or provide your own soundtrack</p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="bg-white p-6 rounded-lg shadow-lg"
          >
            <h3 className="text-xl font-semibold text-navy-800 mb-4">High Resolution</h3>
            <p className="text-gray-600">Get crystal clear quality up to 8K resolution for the best viewing experience</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

const Process = () => {
  return (
    <section id="process" className="py-20 bg-navy-50">
      <div className="max-w-6xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl font-bold text-navy-800 mb-4">How It Works</h2>
          <p className="text-xl text-gray-600">Simple steps to create your perfect montage</p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {[
            {
              title: "Choose Package",
              description: "Select the package that best fits your needs and budget"
            },
            {
              title: "Upload Media",
              description: "Share your photos and videos through our secure platform"
            },
            {
              title: "Professional Editing",
              description: "Our team creates your custom montage with care"
            },
            {
              title: "Final Delivery",
              description: "Receive your completed montage within 1-2 weeks after all media is uploaded"
            }
          ].map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="text-center"
            >
              <div className="w-16 h-16 bg-navy-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold">
                {index + 1}
              </div>
              <h3 className="text-xl font-semibold text-navy-800 mb-2">{step.title}</h3>
              <p className="text-gray-600">{step.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

const Index = () => {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <Features />
      <Process />
      <SampleVideo />
      <PricingSection />
      <section id="order">
        <OrderForm />
      </section>
      <FAQSection />
      <section id="contact">
        <ContactSection />
      </section>
    </div>
  );
};

export default Index;
